module.exports = require("vue-qr");